import { render, staticRenderFns } from "./rebateList.vue?vue&type=template&id=6cc8d224&"
import script from "./rebateList.vue?vue&type=script&lang=js&"
export * from "./rebateList.vue?vue&type=script&lang=js&"
import style0 from "./rebateList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports